import React, { useEffect, useRef, Component } from "react";
//import useUncontrolledProp from 'Uncontrolled'

export default class RadioButton extends Component {
    constructor(props) {
        super(props);
    }

    checkedonChange = (status) => {
        if (!this.props.readOnly)
            this.props.onChange(this.props.value);
    };

    render() {
        //const options = this.props.options;
        return (
            <div className="RadioButtonStyle">
                <input
                    class="radioButton"
                    //className={Styles.input}
                    type="radio"
                    name={this.props.name}
                    //id={inputId}
                    value={this.props.title}
                    disabled={this.props.readOnly}
                    checked={this.props.selected}
                    onChange={this.checkedonChange}
                //tabIndex={-1}
                />
                <div class="radioButtonLabel" onClick={this.checkedonChange}>
                    {this.props.title}
                </div>

            </div>
        );
    }
};
